<template>
  <div class='Header'>
    <div class='PageTItle'>
      <div class="vertical"></div>
      {{title}}
    </div>
    <div class="headerRight" v-if="isPortal !== '1'">
      <img src="@/assets/u110.png"
           class="u100">
      <el-divider direction="vertical"></el-divider>
      <el-dropdown @command="handleCommand"
                   trigger="click">
        <div class="targetHover">
          <img src="@/assets/u106.png"
               class="u106">
          {{ name }}
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="退出"
                            @click="logout">退出</el-dropdown-item>
          <!-- <el-dropdown-item command="设置">设置</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { resetRouter } from '@/router/index'
export default {
  name: 'Header',
  data () {
    return {
      title: '',
      name: JSON.parse(localStorage.getItem('userInfo'))?.userInfoVO?.name || ''
    }
  },
  // 监听属性 类似于data概念
  computed: {
    isPortal () {
      return localStorage.getItem('isPortal')
    },
  },
  watch: {
    $route: {
      handler (to) {
        this.title = this.$route.meta.title
      },
      immediate: true
    }
  },
  // 方法集合
  methods: {
    handleCommand (command) {
      if (command === '退出') {
        this.logout()
      }
      // this.$message('click on item ' + command)
    },
    logout () {
      localStorage.clear();
      this.$message.success('退出成功!')
      resetRouter()
      setTimeout(() => {
        this.$router.push('/login')
      }, 500)
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.Header {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: calc(100% - 200px);
  height: 60px;
  line-height: 60px;
  box-shadow: 5px 5px 5px rgba(161, 161, 161, 0.35);
  padding: 0 20px 0 20px;
  box-sizing: border-box;
  z-index: 999;
  background-color: #fff;

  .PageTItle {
  display: flex;
  align-items: center;
  .vertical {
    width: 5px;
    height: 20px;
    background-color: rgba(40, 151, 255, 1);
    margin-right: 15px;
  }
}
  .headerRight {
    font-size: 14px;
    color: #666;
    .u100 {
      width: 23px;
      height: 20px;
      vertical-align: middle;
    }
    .targetHover {
      cursor: pointer;
      .u106 {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
    }
  }
}
.el-popper[data-v-61dd7a3d] {
  margin-top: -10px;
}
</style>
